export function hasPermission(permissions: string[] | undefined, requiredPermission: string | string[]) {
  if (!permissions?.length) {
    return false;
  }

  if (Array.isArray(requiredPermission)) {
    return requiredPermission.some(permission => permissions.includes(permission));
  }

  return permissions.includes(requiredPermission);
}
